module.exports = __webpack_public_path__ + "media/images/committedadvisor-06ac8416.png";